<pin-page [backLink]="true">
  <pin-page-title [type]="PageTitleType.H1" id="main-content" tabIndex="-1" role="complementary" aria-label="manage-access-title">
    Manage Access
  </pin-page-title>

  <pin-page-description role="complementary">
      You may invite others to view {{ getProductName(true) }} account(s) in the Depositor Control Panel (DCP). Each person you invite
      will receive an email with instructions to set up a DCP user account. After setting up a DCP user account, the person will have
      access to view account activity and participate in Deposit Placement Review for any {{ getProductName(false) }} account(s) that you
      share with them. Click on the "Share Access" button to get started.
  </pin-page-description>

  <pin-page-content role="main">
    <div class="flex flex-col gap-7">
      <div class="flex flex-row justify-start items-center">
        @if (agentsFeatureEnabled && !isSso) {
          <pin-button buttonStyle="filled" buttonType="button" buttonId="share-access-button" redirectUrl="/manage-access/share">SHARE ACCESS</pin-button>
        }
      </div>

      <div class="flex flex-col gap-4">
        @if (sharedAccess) {
          <pin-notification type="success">
            You successfully shared access to your selected accounts.
          </pin-notification>
        }

        @if (revokeAccess) {
          <pin-notification type="success">
            You successfully removed access for {{ userInfo }}.
          </pin-notification>
        }
        <div class="dcp-body">Below you can manage visibility to accounts.</div>
          <pin-generic-data-grid name="ManageAccess"
                                 [showAriaDisabled]="true"
                                 [data]="accountAccessData"
                                 [columnDefinitions]="columnDefinitions"
                                 [displayedColumns]="displayedColumns"
                                 [columnSizes]="[15, 15, 15, 35, 15]"
                                 [dataTransformer]="tableDataTransformer"
                                 [isLoading]="isLoading"
                                 [showExport]="false"
                                 [showPrint]="false"
                                 [initialSortColumn]="initialSortCol"
                                 tooltipContainerClass="manage-access-tooltip"
                                 tooltipText="You are unable to remove access to these accounts for this DCP user. Please contact your institution for help."
                                 initialSortDirection="asc">
          </pin-generic-data-grid>
      </div>
    </div>
  </pin-page-content>
</pin-page>
